<template>
  <div id="app">
    <navTitle v-show="isShowTitle"></navTitle>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import navTitle from './components/commons/navTitle';
export default {
  components: { navTitle },
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  computed: {
    isShowTitle() {
      // 发起业务填写页面 不显示头部

      return !(
        this.$route.name == 'initiator' ||
        this.$route.name == '401' ||
        this.$route.name == '404' ||
        this.$route.name == '500' ||
        this.$route.name == 'initiatorMobile' ||
        this.$route.name == 'approver' ||
        this.$route.name == 'approverTemplateConfig' ||
        this.$route.name == 'approverTemplateConfigMobile' ||
        this.$route.name == 'approverMobile'||
        this.$route.name == 'toDoList'||
        this.$route.name == 'toDoAutomaticList'||
        this.$route.name == 'remainTable'||
        this.$route.name == 'remainDetail'||
        !this.$utils.isPC()
      )
  },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.$store.state.urlParam = this.$utils.getUrlParam();
        this.$nextTick(() => {
          if (
            (this.$route.name == 'processInfo' ||
              this.$route.name == 'iframeForm' ||
              this.$route.name == 'readingLog') &&
            this.$utils.isPC()
          ) {
            this.switchBgc();
          }
        });
        if (this.$route.name == 'onlyReadProcessInfo') {
          this.$store.state.onlyReadHide = false;
        }
      },
      // 深度观察监听
      deep: true,
    },
    '$store.state.isPadding': function () {
      if (
        (this.$route.name == 'processInfo' ||
          this.$route.name == 'iframeForm' ||
          this.$route.name == 'readingLog') &&
        this.$utils.isPC()
      ) {
        this.switchBgc();
      }
    },
  },
  methods: {
    reload() {
      if (this.isRouterAlive) {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    // 设置背景色
    switchBgc() {
      const color = this.$store.state.isPadding ? '#f5f5f5' : '#fff';
      const eHtml = document.getElementsByTagName('html')[0];
      eHtml.style.cssText = `${eHtml.style.cssText};background: ${color}`;
      document.body.style.cssText = `background: ${color}`;
      document.getElementById('app').style.cssText = `background: ${color}`;
    },
  },
  mounted() {
    document.title = '流程门户'
    if (this.$utils.isIE()) {
      // IE路由改变页面不刷新
      window.addEventListener(
        'hashchange',
        () => {
          let currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  },
};
</script>
<style lang="stylus">
#app {
  color #323232
}
</style>



// WEBPACK FOOTER //
// src/App.vue